import { getEnvironmentConfig } from './environments';

// Ottieni la configurazione per l'ambiente corrente
const envConfig = getEnvironmentConfig();

// Configurazione API
export const apiConfig = {
  baseUrl: envConfig.apiBaseUrl,
  timeout: envConfig.timeout,
  debug: envConfig.debug
};

// Esporta anche la configurazione completa per debug
export const fullConfig = envConfig;

// Esporta l'ambiente corrente
export const currentEnvironment = envConfig.name;

// Funzione helper per costruire URL completi
export const buildApiUrl = (endpoint) => {
  // Rimuovi lo slash iniziale se presente
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${apiConfig.baseUrl}/api/app/${cleanEndpoint}`;
};

// Funzione per ottenere il baseUrl corrente
export const getCurrentBaseUrl = () => apiConfig.baseUrl;

// Funzione per cambiare dinamicamente il baseUrl (utile per testing)
export const setBaseUrl = (newBaseUrl) => {
  if (newBaseUrl) {
    apiConfig.baseUrl = newBaseUrl;
  }
};
